export const EMPLOYMENT_TYPES = [
  { value: 'full-time', labelKey: 'Full time' },
  { value: 'part-time', labelKey: 'Part Time' },
  { value: 'internship', labelKey: 'Internship' },
  { value: 'graduate', labelKey: 'Graduate' },
  { value: 'contract', labelKey: 'Contract' },
  { value: 'seasonal', labelKey: 'Seasonal' },
  { value: 'hourly', labelKey: 'Hourly' },
  { value: 'apprenticeship', labelKey: 'Apprenticeship' },
];

export const EXPERIENCE_LEVELS = [
  { value: '0', labelKey: 'No experience' },
  { value: '1', labelKey: '1 Year' },
  { value: '2', labelKey: '2 Years' },
  { value: '3', labelKey: '> 3 Years' },
];

export const EXPERIENCE_FILTER_ALL = { value: 'all', labelKey: 'All' };

export const EXPERIENCE_LABEL_KEYS = EXPERIENCE_LEVELS.map((level) => level.labelKey);

/**
 * Resolve the translatable label for a stored employment type value such as
 * 'full-time'. Read-only screens receive the persisted value from the API, not
 * the label, so they need this before calling the translator. Unknown values
 * are returned unchanged rather than blanked.
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function employmentTypeLabelKey(value) {
  if (!value) {
    return '';
  }

  const match = EMPLOYMENT_TYPES.find((type) => type.value === value);

  return match ? match.labelKey : value;
}

/**
 * Build a value-to-labelKey map, matching the shape the older option objects
 * used so existing template code keeps working.
 *
 * @param {{value: string, labelKey: string}[]} entries
 * @returns {Record<string, string>}
 */
export function toLabelMap(entries) {
  return entries.reduce((map, entry) => {
    map[entry.value] = entry.labelKey;
    return map;
  }, {});
}
